export default {
    callingAPI: false,
    searching: '',
    serverURI: 'http://10.110.1.136:8080',
    user: null,
    token: null,
    userInfo: {
        messages: [],
        notifications: [],
        tasks: []
    },
    listGoodsFilter: null,
    isFooterShow: true,
    isIndexSelectShow: false,
    switchLanguage: 'zh-TW',
    borderStyle: '',
    developerType: '',
    registeredDetail: '',
    ulClassFlag: '',
    isSideBarShow: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js